import React, { useEffect, useRef } from "react"
import { Box, Button, FormControl, InputAdornment, InputLabel, OutlinedInput } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const ExportFileName = ({ download, exportAs, classes, exporting, setOpenExportFileName, fileName, setfileName }) => {
	const [t] = useTranslation("global")
	const fileNameRef = useRef()

	useEffect(() => {
		fileNameRef.current.focus()
	}, [])

	return (
		<Box className={classes.root}>
			<FormControl className={`${classes.margin} ${classes.textField}`} variant="outlined">
				<InputLabel htmlFor="file-name">{`${t("event.fileName")}*`}</InputLabel>
				<OutlinedInput
					inputRef={fileNameRef}
					id="file-name"
					value={fileName}
					onChange={(e) => setfileName(e.target.value)}
					endAdornment={<InputAdornment position="end">{exportAs === "pdf" ? ".pdf" : ".png"}</InputAdornment>}
				/>
			</FormControl>
			<hr className={classes.dividerLine} />
			<FormControl className={classes.formActions}>
				<Button
					variant="contained"
					color="primary"
					className={`${classes.formActionsBtn} ${classes.addBtn}`}
					type="submit"
					disabled={!fileName}
					onClick={download}
				>
					{exporting ? t("event.downloading") : t("event.download")}
				</Button>
				<Button
					className={classes.formActionsBtn}
					style={{
						textTransform: "initial",
						fontSize: "14px",
						padding: "8px 12px",
					}}
					onClick={() => setOpenExportFileName(false)}
				>
					{t("event.field.cancel")}
				</Button>
			</FormControl>
		</Box>
	)
}

export default ExportFileName
